import {Component, computed, inject, input, InputSignal} from '@angular/core';
import {MetaField} from "../../core/definitions/meta-field";
import {ViewField} from "../../core/definitions/object-view";
import {MatCheckbox} from "@angular/material/checkbox";
import {SharedModule} from "../../shared/shared.module";
import {Section, SectionsContainer} from "../../core/definitions/sections-container";
import {ObjectCopyService} from "../object-copy.service";

@Component({
  selector: 'app-object-copy-field',
  imports: [
    MatCheckbox,
    SharedModule
  ],
  templateUrl: './object-copy-field.component.html',
  styleUrl: './object-copy-field.component.scss',
})
export class ObjectCopyFieldComponent {
  readonly objectCopyService = inject(ObjectCopyService);

  field: InputSignal<MetaField> = input();
  section: InputSignal<Section> = input();

  sectionsContainer = computed<SectionsContainer>(() =>
    this.objectCopyService.sectionsContainer());

  viewField = computed<ViewField>(() =>
    this.objectCopyService.getViewField(this.section(), this.field()));

  isFieldSelected = computed<boolean>(() =>
    this.objectCopyService.getIsFieldSelected(this.field()));

  isFieldRequired = computed<boolean>(() =>
    this.objectCopyService.getIsFieldRequired(this.field()));
}
